var parallax;

parallax = function() {
  var $, module, moduleName;
  moduleName = "parallax";
  $ = require('jquery');
  module = $("." + moduleName);
  if (module.length < 1) {
    return false;
  }
  return module.each(function() {
    var Parallax, back, cityParallax, thisBanner;
    thisBanner = $(this);
    Parallax = require('parallax-js');
    back = this;
    return cityParallax = new Parallax(back);
  });
};

module.exports = parallax;
